<i18n>
{
  "ru": {
    "ourPartners": "Наши партнёры"
  },
  "uk": {
    "ourPartners": "Наші партнери"
  }
}
</i18n>

<template>
  <div class="container main">
    <div class="row">
      <div class="col-sm-12 col-xl-10">
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-sm-12 col-xl-9">
            <SliderMain />
          </div>
        </div>
        <div class="row items-content">
          <TabItems />
        </div>
        <div class="row items-content list-mall">
          <TabPlaces />
        </div>
      </div>
      <div class="col-xl-2 col-sm-12">
        <div class="home-banner">
          <img
            :src="
              require('../assets/images/sidebar-blocks/sidebar-block-1.ru.png')
            "
          />
        </div>
        <div
          class="partners"
          v-if="$store.state.GlobalData.partners && mainPartners.length > 0"
        >
          <div class="header">
            <span>{{ $t("ourPartners") }}</span>
          </div>
          <div class="block">
            <slick class="partners-slider" ref="slick" :options="slickOptions">
              <div v-for="item in mainPartners" :key="item.id">
                <router-link
                  :to="'/' + locale + '/partners/' + item.url[locale]"
                  rel="nofollow"
                >
                  <img
                    style="width:100%;"
                    :src="item.logo"
                    :alt="item.name[locale]"
                  />
                </router-link>
              </div>
            </slick>
          </div>
        </div>
      </div>
    </div>
    <div class="row items-content"></div>
  </div>
</template>

<script>
import Slick from "vue-slick";

import TabPlaces from "@/components/TabPlaces.vue";
import TabItems from "@/components/TabItems.vue";
import SliderMain from "@/components/SliderMain.vue";

export default {
  computed: {
    mainPartners() {
      let cityId = this.$store.state.GlobalData.currentCity;
      let partners = this.$store.state.GlobalData.partners;
      let arr = [];
      for (let i = 0; i < partners.length; i++) {
        if (partners[i].main_page && partners[i].city_id === cityId.id) {
          arr.push(partners[i]);
        }
      }
      return arr;
    }
  },
  data() {
    return {
      slickOptions: {
        dots: false,
        autoplay: true,
        infinite: true,
        vertical: true,
        verticalSwiping: true,
        centerMode: false,
        focusOnSelect: false,
        autoplaySpeed: 4000,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              vertical: false,
              verticalSwiping: false
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              vertical: false,
              verticalSwiping: false
            }
          },
          {
            breakpoint: 789,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              vertical: false,
              verticalSwiping: false
            }
          }
        ]
      },
      locale: this.$route.params.locale
    };
  },
  watch: {
    $route(to) {
      this.locale = to.params.locale;
    }
  },
  components: {
    Slick,
    TabPlaces,
    TabItems,
    SliderMain
  }
};
</script>

<style>
.partners-slider {
  overflow: hidden;
  position: relative;
}
.partners-slider .slick-slide {
  padding: 10px;
}
.partners-slider .slick-prev,
.partners-slider .slick-next {
  font-size: 0;
  line-height: 0;
  position: absolute;
  top: 50%;
  display: block;
  width: 20px;
  height: 20px;
  padding: 0;
  -webkit-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  color: transparent;
  border: none;
  outline: none;
  background: transparent;
}
.partners-slider .slick-arrow {
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: contain !important;
  opacity: 0.5;
}
.partners-slider .slick-arrow:focus {
  outline: none;
}
.partners-slider .slick-prev {
  left: 0;
  top: 10px;
  width: 100%;
  z-index: 1049;
  background: rgba(0, 0, 0, 0.7);
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAASXSURBVGhD7ZrLaxVXHMcjiq+tWEGDYKs7H4Ea8BUXFkppabdCxG1f1vhfKDHoX5KK0mpi0K61dltB7Eaj4s5HFdpqk36+Z74zzM3NzZwzd+5NF/cDX2bm/J6He+fMuZMMDRgwoP8sLi6uW1hY2IOOo8+sMbRbNrv9/6C5NW50ivPfOP7NcVlkQ/fQRXSEoTVOs3rQxGaamUB/hC5roFh0Fm1y2v5BfX0Cp9GzrJ12sL1Dj9B9S+fvbW4D2zN0yiV6D8U+QLOuX6Am0Q10Bu1laL1DCjQmG/oBzaC2iXl8q0N6A3U+pkjLp8D1n0jf9+12i4aYHWhKOZwuwPUTDiN2axaSawV6nZXK4Hoa7bBLbcgxjH502gDXr9BxuzQDCQ+S+2VWIhTRqvS1zY2hnM6d85LrfTZ3B4m2oeLrxPlr9InNjaPcquFyqvcUdXfPkEer080sZfZJoBM29wzVUC2XVd3rNtWDBKedK6fxr1MnqP2tawa4HrcpDQI3oefOo0TTNvUNal5xedV/op5sioegc86hJFpiu16dUqH0Tuq+yboIfZyxKQ5idG8U2w7OJ21KhvBjki+Tofal0ARw/tDDcRAw5lgFa6uR/LATxOmmfWPVWiSI00Oz2AFwftimanDWLjbA+YyHkyBOk3jrNMrzVmM2J0HcnNMozwUPV4PzPccpMO17CWoYFZPI0ZhsdouGmLNOoRx3Pbwy+OpH0T9ZWAjcb1MUahSVPwk9e8rPhOTJ4H/A4SEfh7U2dQbHPVlICHrHoW0X2wk1iJZO4kur9mQI0a65vFP+0KbO4KRVJkDwvIcrUWNq0KHFJGyWvavJ4KsdcU71KkjAF3ZWsd89vCJqCHWcRI7GZLNb0mTwu+8wxX3u4c7glDQRNYIqJ5Ejm3zsHj0ZfNImgl/0V0sNoOhJ5MhHvg6Lmgz25K+WXtkEONcNtuzNjm0UJU8iR76KcXg+mVGbW2B8Ayo/FHfZ1Bn8opZfTHqD8ot9kiaRQ8xXinWO28ppUwuMj8hH2L96+RU4/5qFhcCOD0TMmswsSp5EDrGazIxyeagN7BOhGeD8joerwXnScQqstUVpEnoob1HOe7ganI86ToF6zVNr09gE1NaLiX/djvo5ZFM1+C/dxk/Z1HeofdltqI8HHo6HoPJGTdvwYZv6BqX1w6q8Mn5vUzwE6adu+e3JFZv6BjWvubzqz3PYaFMaBI9naTK4/samnkOt71w2wPVJm9IhXvfK9SxVSKbnRfRGry6qoVouq7o/21QfkmxFxfaA816/oPsUFe+COX+MttjcHSTaR86evzIlr97SF58ENPfKNIeEeon9ygUCXF/lsNMutVEOchU3tuD6BRqzS7OQf4Tk5V2oCmppvoSS33spxrHFEiu41h+Fkn5iJ0MB3TPaG7XAmHYAc0h/ituPNjikQGPogH1uoeX+0PMTauaeiIFi4+ip67ehJtE8yv/0pvO2xnNsr7/EdgP1N1Jcf2p7mLWTDrEPnKPtE1wVaOQwuoDuovLK0wK2v9Ad+8a/NVwN6HctTX7E8RjH/B8Gjnos7kfRgAEDGmRo6D9X8wl1OYEB0QAAAABJRU5ErkJggg==");
}
.partners-slider .slick-next {
  left: 0;
  top: unset;
  bottom: -10px;
  width: 100%;
  z-index: 1050;
  background: rgba(0, 0, 0, 0.7);
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAT+SURBVGhD7ZpJiBRnHMXHPRGDRg3uCi64hPEgiKcsJ0FB0UPU8eIoMoFIjBFzyGECBjfQgEQMKmguUclycHDNISiiJ9HDXFyIEeKMQZOYEEMMUWfyezWvplpnuru6qnpJ8MHjq/rv/66qrq++qrrn+L+is7NzImzs6Og4wHiO8Q78g+1OxsfwPrwGj8FtcD6qwXavLihmOHwfXlbBpQK/v+BRuIDdPg5bOZB0JMl3wgdBRYDtnxm+YlzH+CbjWMYX7CKfoXAGXIJuC7wAH7MfgO1WuIzN8jekJLCJhL86uaBTZRG7A2wWG/iNhRvhD4pn6LScaZPsQQIdhRNduYImWmC91alAuP7EWgXbHfshQ5PV2YHAs+CPTvITXGRVpiD8EGLvgR3OdZChv9XpQLC5MDyVvmMYbVXZQA5dR78553GGgVYlA0Hq4T0HPJo6YAkg32x4x7m/YehnVWnAUddEeDp9wdDXqoqBvFNh+EN+YnF84NcHx5MOcJahYkfiWZB/HtT9RlhscTxQeJOb0IU9yuKqgRredj334AiLCwPDV+AvdizLv1MSUEvw18+4z6LCwHCnHVosqglQ0mRqegg1b5tmce/AQHOnB1DI5GaXJajpU//IBy3qHRhsqMWjEYK6JsBHUHf+YRb3BAZX3EjNXBvPgtp0gxR6n8JgMElaRl3oJU8AKwXqa3Cdpyx6GugabfClRTUJ6hsBn0A9tPX8wVHsdyPrLCoITEfDId5NDfKOJ16sGy+2ra51jkUREJ638g2L8gKzl7H7E34PJ1icGMRYA/UrH7CoILA74lobLIqAsM3KcRblBWYDsLtk+5swcTP4qolw2v6OxQWB3ce2b7YoAsJwoeBFiwoCUx2V4FmdMVEz+OQ28aHFRYHtevvssiiCFU+8Gwu4JG4G20RNCNivtt9nFkVA+EhK78YGLiU3g03iJgR8wknkXosiIAyeyMBQi2IDn9jNoEvVhIDfJvtvtygCwqtWzrKoJOBatBlkqZsQ8N3tGO9ZFAFhi5WlPbzkAPe8zbCdSRMC/uFD30KLIiDcauUWixKBED2agZk1QQg9vQaPv2CixRFQai1WiS5alBiEyW1GT5mZNCEQo96xblr0NNANRqlnYz24jLE4MYjX3YzAduomBOI0O17+J0WUWvKR0SaLUoFQauYwfNeiVCCeTqsbrjH/VAqlVsVlpLXYbFb4MgR1LXR9txjyL3ZLiVEwswSNFtcMqO2iCmMsPifD7i0bt8GXLK46qGWl67oNi88HsdWrg3N22mNxVUEpWvUMl09XWFwcGL8KtfQiJL5BZgFqz131/Nbi+MApmJiB39mu2tIQuberCEa9k0y26onj5w6i83K6xRUDOTc6v+5vRZ9c84IY/QgQzsG07jrXqrKCdLpOdzivbtDpT2+CDIJfO2h5XonlgBxaJQnXeXWdLrUqPYipI7MLhnOmE3CK1ZmBmCth+O+kOdprVmUL4uuVmF5DK5HOW63F9pyBlgjiLIDBzU5g+wxDeV/xkUQL3fth8I6c8R94Eq5gd6TNCgI7/aXqtV4zvK44AtvtcLnNKgMSToOH4N+uQ4VobUov/vU1w2a4Hq5FpXfzH8Dd8DS82+XRBfZvQX1o0P2BQcVBcn3RoEJ1VLq/hCgGbPXQpSP7OrsVfz9ZEBSkF/9zYAP8COozDxW7F90Oxg1Q10PsZaPn+G+iru5fjTd1h7uXIiwAAAAASUVORK5CYII=");
}
.partners-slider .slick-arrow:before {
  content: unset;
}
.partners-slider .slick-arrow:hover {
  opacity: 1;
}
@media (max-width: 1280px) {
  .partners-slider .slick-prev {
    top: 50%;
    left: 0;
    width: 20px;
    height: 100%;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAA4klEQVRIic3VO0oDQQDH4SGmEVEjqOBZ0vhoAz5SeQN7T2HhOTSX0MaQ+Go0JxGURCWfhQgx7iyEmQ3+6+X37WwxG8J/HZZwgoWq4le+10E9d/za711mQbCMG8U7T42voBuJf6CdEl9FLxL/xHFV8Xccpcb7JfHDlHgDt5H4CAep8buS+H5KfBGPkfgQrVl6tSIjhDCOPD8OIQxnfem/QvknesNeLuQ+grxidx7ITg5kDQ9VI+t4KkG2cyAbeI4gL2jmQDYxiCBnycAEMn2SPD+cKeTnJBdZ4xPIFk5RdBvMb18v0WMq8w8hcQAAAABJRU5ErkJggg==");
  }
  .partners-slider .slick-next {
    top: 50%;
    right: 0;
    left: unset;
    width: 20px;
    height: 100%;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAA6ElEQVRIicXVO04DMRRG4TuRaIAOJF67QKLgLbIYKmq2QElHthUEIiGsgAbx7BAfRVAkRuOBMJ7wl7Z8zrVlX0f8d3CMjbbgZ8a5yypBgXPfM8J6LsGp6gyxlkOwhceEZIDVHJJNPLS9k208zULy3PZx7cxCslsjucRyDskhXhOSPhbLazpTOt4j4iMxtxARc9MWPckPRzTSpJVgrwZ+2yZ8qEl/wj5e2oIf1MAHmrxidPGWgF9j5bes1DU9ioj5ivGriOgWRXH/l8InMf5wLkqV38jREkqS3he8L0crqJB0cIKl7PBc+QQBuj8qhGGTdgAAAABJRU5ErkJggg==");
  }
  .partners-slider .slick-list .slick-slide img {
    height: 172px;
    width: 100%;
    object-fit: contain;
  }
}
</style>
